module.exports = __webpack_public_path__ + "img/team-ux-bg.6c1deb07.svg";